'use client';

import React from 'react';
import { Tooltip } from 'src/components';
import { isNewOpportunity } from 'src/utils/isNewOpportunity';

interface StrategyNewOpportunityBadgeProps {
  dateAdded: string;
  lastRefreshed: string | null;
}

const StrategyNewOpportunityBadge: React.FC<
  StrategyNewOpportunityBadgeProps
> = ({ dateAdded, lastRefreshed }) => {
  if (
    !isNewOpportunity({ date_added: dateAdded, last_refreshed: lastRefreshed })
  )
    return null;

  return (
    <Tooltip content="New Opportunity" position="top">
      <span
        aria-label="New opportunity"
        data-testid="strategy-new-opportunity-badge"
        className="px-1.5 py-0.5 text-xs font-medium text-green-700 bg-green-100 rounded-full"
      >
        New
      </span>
    </Tooltip>
  );
};

export default StrategyNewOpportunityBadge;
